// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { caseInsensitiveLowerEnum } from '@/constants/case-insensitive-enum';
import { z } from 'zod';

export const activeAttentionSeveritySchema = caseInsensitiveLowerEnum([
  'notice',
  'warning',
  'critical',
]);

export type ActiveAttentionSeverity = z.infer<
  typeof activeAttentionSeveritySchema
>;

/**
 * Machine-readable code describing which condition tripped the signal.
 */
export const attentionReasonSchema = caseInsensitiveLowerEnum([
  'open_not_shipped',
  'shipped_not_delivered',
  'delivered_not_received',
]);

export type AttentionReason = z.infer<typeof attentionReasonSchema>;

export const ATTENTION_SEVERITY_LABELS: Record<
  ActiveAttentionSeverity,
  string
> = {
  notice: 'Notice',
  warning: 'Warning',
  critical: 'Critical',
};
